/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var isProduct = document.body.classList.contains("template-product");

  //if ( isProduct ) {
  var quantity = document.querySelector('input[name="quantity"]');
  var addons = document.querySelectorAll("[data-add]");
  var price = document.querySelector(
    ".ProductMeta__Price[data-money-convertible]"
  );
  var compareAtPrice = document.querySelector(
    ".ProductMeta__Price.Price--compareAt[data-money-convertible]"
  );

  if (price) price.setAttribute("data-org", parseInt(price.textContent));
  if (compareAtPrice)
    compareAtPrice.setAttribute(
      "data-org",
      parseInt(compareAtPrice.textContent)
    );

  addons.forEach(function (item) {
    item.addEventListener("click", function (e) {
      addons.forEach(function (item) {
        item.classList.remove("is-active");
      });

      e.preventDefault();
      var q = e.target.dataset.add;
      if (quantity) quantity.value = q;

      item.classList.add("is-active");

      if (!isProduct) {
        price.textContent = formatMoney(
          parseInt(price.getAttribute("data-org") * 100) * q
        );
        if (compareAtPrice)
          compareAtPrice.textContent = formatMoney(
            parseInt(compareAtPrice.getAttribute("data-org") * 100) * q
          );
      } else {
        price.textContent = formatMoney(parseInt(window.item.Price) * 100 * q);
        if (compareAtPrice)
          compareAtPrice.textContent = formatMoney(
            parseInt(window.item?.CompareAtPrice) * 100 * q
          );
      }
    });
  });
  //}

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */

  /* eslint-disable */

  function formatMoney(cents, format = theme.moneyFormat) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }

    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      if (typeof precision == "undefined") {
        precision = 2;
      }

      thousands = theme.thousandsSeperator;
      decimal = thousands == "," ? "." : ",";

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (format.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0);
        break;
    }

    return format.replace(placeholderRegex, value);
  }
})();

/**
 * Giftwrapping
 */
if (window?.giftwrap) {
  var giftWrap = window.giftwrap;

  Shopify.Cart = Shopify.Cart || {};

  Shopify.Cart.GiftWrap = {};

  Shopify.Cart.GiftWrap.set = function (body) {
    var headers = new Headers({ "Content-Type": "application/json" });

    var request = {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        quantity: 1,
        id: giftWrap.id,
        attributes: {
          [giftWrap.strings.label]: true,
        },
        properties: {
          [giftWrap.strings.props.label]: giftWrap.strings.props.caption,
        },
      }),
    };

    fetch("/cart/add.js", request);
  };

  Shopify.Cart.GiftWrap.remove = function () {
    var headers = new Headers({ "Content-Type": "application/json" });

    var request = {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        quantity: "0",
        id: `${giftWrap.id}`,
        attributes: {
          [giftWrap.strings.label]: "",
        },
      }),
    };

    fetch("/cart/change.js", request);
  };

  // When the gift-wrapping checkbox is checked or unchecked.
  document.addEventListener("click", function (event) {
    if (event.target.name == `attributes\[${giftWrap.strings.label}\]`) {
      var label = event.target.parentNode;
      var forceReloadTrigger = label.querySelector("[data-action]");
      forceReloadTrigger.click();

      if (event.target.checked) {
        Shopify.Cart.GiftWrap.set();
      } else {
        Shopify.Cart.GiftWrap.remove();
      }
    }
  });

  if (document.querySelector("#gift-note")) {
    document
      .querySelector("#gift-note")
      .addEventListener("change", function (evt) {
        var note = evt.target.value;
        var headers = new Headers({ "Content-Type": "application/json" });

        var request = {
          method: "POST",
          headers: headers,
          body: JSON.stringify({ attributes: { "gift-note": note } }),
        };

        fetch("/cart/update.js", request);
      });
  }
}

/**
 * Urgency Cart countdown and clearing
 */
(function () {
  class UrgencyCartDrawer {
    constructor({ el }) {
      this.timerInMilliseconds = 3_600_000;
      this.element = el;
      this.timestampName = "cart_last_added_timestamp";
      this.timerElement = null;
      this.timerSpan = null;
      this.countdownInterval = null;

      this.updateTimestamp = this.updateTimestamp.bind(this);
    }

    setTimerElementRefs() {
      this.timerElement = this.element.querySelector(
        "[data-cart-reset-element]"
      );
      this.timerSpan = null;

      if (this.timerElement) {
        this.timerSpan = this.timerElement.querySelector(
          "[data-cart-reset-timer]"
        );
      }
    }

    showTimerElement() {
      if (!this.timerSpan) return;

      this.timerElement.hidden = false;
      this.initTimerCountdown();
    }

    updateTimerSpan(el, timestamp) {
      var currentTime = new Date().getTime();
      var differenceInMilliseconds = currentTime - timestamp;
      var timeLeft = this.timerInMilliseconds - differenceInMilliseconds;
      var timeLeftInMinutes = Math.floor(timeLeft / 60_000);
      var timeLeftInSeconds = Math.ceil(timeLeft / 1_000);

      if (timeLeftInSeconds <= 0) {
        this.eraseCookie(this.timestampName);
        this.clearCart();
        this.stopCountdown();
        this.timerElement.hidden = true;
      }

      this.setCountdownText(el, timeLeftInMinutes, timeLeftInSeconds);
    }

    setCountdownText(el, mins, secs) {
      var string;
      var translation = "";

      if (secs > 60) {
        if (mins > 1) translation = el.dataset.minsTranslation;
        else translation = el.dataset.minTranslation;

        string = `${mins} ${translation}`;
      } else {
        if (secs > 1) translation = el.dataset.secsTranslation;
        else translation = el.dataset.secTranslation;

        string = `${secs} ${translation}`;
      }

      el.textContent = string;
    }

    stopCountdown() {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }

    initTimerCountdown() {
      if (!this.timerSpan) return;

      var _this = this;

      if (_this.countdownInterval) this.stopCountdown();

      var currentTimestampCookie = this.getCookie("cart_last_added_timestamp");

      this.updateTimerSpan(_this.timerSpan, currentTimestampCookie);
      this.timerElement.hidden = false;

      _this.countdownInterval = setInterval(function () {
        _this.updateTimerSpan(_this.timerSpan, currentTimestampCookie);
      }, 1000);
    }

    checkTimestamp() {
      var currentTimestampCookie = this.getCookie("cart_last_added_timestamp");
      var currentTime = new Date().getTime();

      var differenceInMilliseconds = currentTime - currentTimestampCookie;

      if (differenceInMilliseconds >= this.timerInMilliseconds) {
        this.eraseCookie(this.timestampName);
        this.clearCart();
        this.stopCountdown();
        this.timerElement.hidden = true;
      } else {
        this.showTimerElement();
      }
    }

    clearCart() {
      fetch("/cart/clear.js").then(function () {
        if (window.ThemeCart) {
          window.ThemeCart.itemCount = 0;
          window.ThemeCart._rerenderCart();
        }
      });
    }

    updateTimestamp() {
      this.setCookie(this.timestampName, new Date().getTime());
    }

    setEventListeners() {
      var _this = this;

      document.addEventListener("cart:rerendered", function (e) {
        _this.setTimerElementRefs();

        if (e.detail.itemCount > 0) {
          _this.updateTimestamp();
          _this.checkTimestamp();
        } else {
          _this.eraseCookie(this.timestampName);
          _this.stopCountdown();
          _this.timerElement.hidden = true;
        }
      });
    }

    setCookie(name, value) {
      document.cookie = `${name}=${value} ; expires=Sun, 1 Jan 3000 00:00:00 UTC; path=/`;
    }

    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }

      return null;
    }

    eraseCookie(name) {
      document.cookie =
        name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }

    init() {
      this.setTimerElementRefs();
      this.setEventListeners();
      this.checkTimestamp();
    }
  }

  var cartDrawer = document.querySelector("#sidebar-cart");
  const enableUrgency =
    cartDrawer && cartDrawer.querySelector("[data-cart-reset-element]") !== null
      ? true
      : false;

  if (enableUrgency) {
    var urgencyCart = new UrgencyCartDrawer({ el: cartDrawer });
    urgencyCart.init();
  }
})();
